import { Box } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { Col, Row } from "antd";
import useCreateCentroDeCusto from "core/features/centro-de-custo/hooks/useCreateCentroDeCusto";
import { CentroDeCustoResponse } from "core/features/centro-de-custo/typings";
import { showErrorAxios } from "infra/helpers/alerta";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import OutlineButton from "ui/components/Button/OutlineButton";
import DefaultButton from "ui/components/Button/PrimaryButton";
import Field from "../Field";

function FormCentroDeCusto({
  onSuccess,
  onClose,
  visible,
  defaultValue,
  tenantId,
  id,
}: {
  onSuccess: (data: any) => Promise<void>;
  onClose: () => void;
  visible: boolean;
  defaultValue?: CentroDeCustoResponse;
  tenantId?: string;
  id?: string;
}) {
  const { control, handleSubmit, reset, watch, formState } = useForm<
    Pick<CentroDeCustoResponse, "nome" | "saldo">
  >({
    reValidateMode: "onChange",
    mode: "onChange",
  });

  const { isLoading, mutate: handleSave } = useCreateCentroDeCusto(tenantId);

  useEffect(() => {
    if (defaultValue) {
      reset({
        nome: defaultValue?.nome,
        saldo: defaultValue?.saldoInicial ?? defaultValue?.saldo,
      });
    }
  }, [visible, defaultValue, reset]);

  const onSubmit = async (
    data: Pick<CentroDeCustoResponse, "nome" | "saldo">
  ) => {
    handleSave({ ...data, id } as any, {
      onSuccess: (res) => {
        reset();
        onSuccess(res.data.id);
      },
      onError: (res) => {
        showErrorAxios(res);
      },
    });
  };

  return (
    <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
      <Text as="h3" fontSize={20} mb="16px" fontWeight="500">
        {id ? `Editar` : `Cadastrar`} centro de custo
      </Text>
      <Row>
        <Box as={Col} sm={24} mb={4}>
          <Field
            label="Nome do centro de custo"
            control={control}
            name="nome"
            rules={{
              required: true,
            }}
          />
        </Box>
      </Row>
      <Row gutter={16}>
        <Box as={Col} sm={12} mb={4}>
          <Field
            label={"Saldo inicial"}
            control={control}
            name="saldo"
            rules={{
              required: true,
            }}
            inputProps={{
              type: "money",
              color: watch("saldo") >= 0 ? undefined : "red",
              fontWeight: "bold",
            }}
          />
        </Box>
      </Row>

      <Box
        pt="32px"
        justifyContent="flex-end"
        d="flex"
        gridGap="8px"
        flexDir="row"
      >
        <OutlineButton
          disabled={isLoading}
          onClick={() => {
            onClose?.();
            reset();
          }}
        >
          Cancelar
        </OutlineButton>

        <DefaultButton
          type="button"
          isLoading={isLoading}
          onClick={handleSubmit(onSubmit)}
          disabled={!formState.isValid || isLoading}
          minWidth={"120px"}
        >
          Salvar
        </DefaultButton>
      </Box>
    </form>
  );
}

export default FormCentroDeCusto;
